export default __webpack_public_path__ + "static/media/zoom-minus.29cdd6d7.svg";